import { render, staticRenderFns } from "./BlogPostComponent.vue?vue&type=template&id=3ff82bfa&scoped=true"
import script from "./BlogPostComponent.vue?vue&type=script&lang=js"
export * from "./BlogPostComponent.vue?vue&type=script&lang=js"
import style0 from "./BlogPostComponent.vue?vue&type=style&index=0&id=3ff82bfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff82bfa",
  null
  
)

export default component.exports